<template>
  <ais-infinite-hits :class="typeClassName">
    <template slot="item" slot-scope="{ item, insights }">
      <ResultItem
        :class="`item item-${typeClassName}`"
        :item="item"
        :type="type"
        :store="store"
        :insights="insights"
        @modalInterface="modalInterface"
      />
    </template>
  </ais-infinite-hits>
</template>

<script>
import ResultItem from './ResultItem.vue';

export default {
  data() {
    return {
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    store: {
      type: Object,
      required: true,
    }
  },
  components: {
    ResultItem,
  },
  methods: {
    transformItems(items) {
      return items.map(item => ({
        ...item,
        name: item.name.toUpperCase(),
      }));
    },
    modalInterface(modalType) {
      // console.log('reemition back to parent component Results');
      // console.log('passed modalType: ' + modalType);
      this.$emit('modalInterface',modalType);
    },
  },
  computed: {
    typeClassName() {
      return this.type.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.list,
.grid {
  display: flex;
  flex-direction: column;

  /deep/ .ais-InfiniteHits-list {
    display: flex;
  }

  /deep/ .ais-InfiniteHits-loadMore {
    margin: 0 auto;
    @include theme-value(background, brand-color-one);
    color: $white;
    padding: 10px 12px;
    font-family: inherit;
    font-size: inherit;
    cursor: pointer;
    border: none;
    transition: background 0.2s;
    &:hover {
      @include theme-value(background, brand-color-one--dark);
    }
  }
}

.list {
  /deep/ .ais-InfiniteHits-list {
    flex-direction: column;
  }
  .item {
    margin-bottom: 36px;
    @media screen and (max-width: $tablet) {
      margin-bottom: 16px;
    }
  }
}

.grid {
  /deep/ .ais-InfiniteHits-list {
    margin: 0 -18px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: stretch;
    @media screen and (max-width: $tablet) {
      margin: 0 -9px;
    }
    .ais-InfiniteHits-item {
      width: calc(100% / 4);
      margin-bottom: 36px;
      @media screen and (max-width: $widescreen) {
        width: calc(100% / 3);
      }
      @media screen and (max-width: $desktop) {
        width: calc(100% / 2);
        margin-bottom: 18px;
      }
      @media screen and (min-width: $tablet + 1) and (max-width: 900px) {
        width: 100%;
      }
      @media screen and (max-width: $tiny-mobile) {
        width: 100%;
      }
    }
    @media all and (-ms-high-contrast: none) {
      .ais-InfiniteHits-item {
        // so width doesn't work on IE, but flex-basis not on the rest ahah
        flex-basis: calc(100% / 4);
        margin-bottom: 36px;
        @media screen and (max-width: $widescreen) {
          flex-basis: calc(100% / 3);
        }
        @media screen and (max-width: $desktop) {
          flex-basis: calc(100% / 2);
          margin-bottom: 18px;
        }
        @media screen and (min-width: $tablet + 1) and (max-width: 900px) {
          flex-basis: 100%;
        }
        @media screen and (max-width: $tiny-mobile) {
          flex-basis: 100%;
        }
      }
    }
  }
  .item {
    height: 100%;
    margin: 0 18px;
    @media screen and (max-width: $tablet) {
      margin: 0 9px;
    }
  }
}

/deep/ .ais-InfiniteHits-loadMore--disabled {
  display: none;
}

.map /deep/ .ais-InfiniteHits-list {
  height: 300px;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}

.map /deep/ .ais-InfiniteHits-item {
  display: inline-block;
  margin: 10px;
}

.map /deep/ img {
  width: 100%;
}
</style>
